import React, { useContext } from 'react'
import { Button, Grid, GridCell, Modal, Spacer, Text, View } from 'oio-react'
import { Route, useRouteMatch } from 'react-router-dom'
import { settingsDesignUrl } from 'src/components/utils/urls'
import TypographyEditor from 'src/apps/AdminWorkspace/apps/TypographyEditor'
import ProtoHeadingBlock from 'src/components/Settings/ProtoHeadingBlock'
import ProtoReturnBar from 'src/components/Settings/ProtoReturnBar'
import ThemeContext from 'src/libraries/contexts/Theme'

const SettingsDesignTypography = () => {
   const match = useRouteMatch()
   const theme = useContext(ThemeContext)

   return (
      <View>
         <ProtoReturnBar
            display="block[a-b] none[c-f]"
            returnLinkName="Design Settings"
            returnLinkTo={settingsDesignUrl}
         />
         <View display="flex" justifyContent="center">
            <View
               width="100%"
               maxWidth="100%[a-c] 600px[d-f]"
               padding="40px 20px">
               <View
                  width="100%"
                  display="flex"
                  flexFlow="column[a-c] row[d-f]">
                  <View>
                     <ProtoHeadingBlock
                        title="Typography"
                        description="Customize the typography and paragraph styles that will be used throughout your site"
                     />
                  </View>
               </View>
               <Spacer size="3" />
               <View
                  float="left"
                  width="100%"
                  padding="15px[a] 20px[b-f]"
                  borderRadius="5px"
                  backgroundColor="#fff">
                  <Grid columns="1[a] 2[b-f]">
                     <GridCell>
                        <View
                           display="flex"
                           alignItems="center"
                           justifyContent="center"
                           width="100%"
                           padding="15px 20px 25px 20px"
                           borderRadius="3px"
                           border="1px solid #ddd"
                           backgroundColor="#fafafa">
                           <View>
                              <Text size="15" lineHeight="100%" weight="medium">
                                 Aa
                              </Text>
                              <Text size="4" lineHeight="100%">
                                 Abcdefghijklm
                                 <br />
                                 nopqrstuvwxyz
                              </Text>
                           </View>
                        </View>
                     </GridCell>
                     <GridCell>
                        <Button
                           linkTo={`${match.url}/editor`}
                           type="submit"
                           name="Open Typography Editor"
                           color={theme.protoSettingsHighlightBackgroundColor}
                           textColor={theme.protoSettingsHighlightForegroundColor}
                           textWeight="medium"
                           size="md"
                           textSize="0.9"
                           padding="25px"
                        />
                     </GridCell>
                  </Grid>
               </View>
            </View>
         </View>
         <Route path={`${match.url}/editor`}>
            <Modal
               width="100%"
               height="100%"
               overlayBackgroundColor="rgba(0,0,0,0.8)"
               open>
               <TypographyEditor returnLinkTo={match.url} />
            </Modal>
         </Route>
      </View>
   )
}

export default SettingsDesignTypography
